"use strict"
exports.__esModule = true;
exports.EnterpriseIconConfig = {
  name: 'EnterpriseIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M438.9,0 L0,109.7 L0,882.3 L585.1,1024 L658.3,1024 L1024,877.7 L1024,109.7 L512.1,0 L438.9,0 Z M73.2,825.1 L73.2,200.9 L576,312.6 L576,944.3 L511.6,929 L511.6,819.4 L128.4,726.7 L128.4,837.8 L73.2,825.1 Z M640,327 L960,203.1 L960,824.2 L895.9,849.7 L895.9,763.5 L704,839.4 L704,926.5 L640,952.5 L640,327 Z M128.4,434.2 L511.6,525.2 L511.6,376.7 L128.4,290.9 L128.4,434.2 Z M704,400.5 L704,546.8 L896,471 L896,324.8 L704,400.5 Z M128.4,653.6 L511.6,745.2 L511.6,597.7 L128.4,507.3 L128.4,653.6 Z M704,620 L704,766.3 L896.1,690.5 L896.1,544.2 L704,620 Z',
  yOffset: 0,
  xOffset: 0,
};
exports.EnterpriseIcon = require('../createIcon').createIcon(exports.EnterpriseIconConfig);
exports["default"] = exports.EnterpriseIcon;